export class Roster {
    rosterNo: number = 0;
    client?: string = "";
    campusName?: string = "";
    activity: string = "";
    demographics: string = "";
    marketingPlan: string = "";
    checkNo?: string = "";
    checkAmt: number = 0;
    checkDate?: string = "";
    batchNum?: string = "";
    policyNo?: number = 0;
    bankDepositDate?: string = "";
    campusID: number = 0;
    planRate: number = 0;
    studentRate?: number = 0;
    createdBy?: string = "";

    constructor(rosterID: number, client: string, campusName: string, activity: string, demographics: string, marketingPlan: string, checkNo: string, checkAmt: number, batchNum: string, policyNo: number, bankDepositDate: string, campusID: number, planRate: number, studentRate: number) {
        this.rosterNo = rosterID;
        this.client = client;
        this.campusName = campusName;
        this.activity = activity;
        this.demographics = demographics;
        this.marketingPlan = marketingPlan;
        this.checkNo = checkNo;
        this.checkAmt = checkAmt;
        this.batchNum = batchNum;
        this.policyNo = policyNo;
        this.bankDepositDate = bankDepositDate;
        this.campusID = campusID;
        this.planRate = planRate;
        this.studentRate = studentRate;
    }
}

export class ArchivedRoster {
    rosterNo?: number = 0;
    client?: string = "";
    campusName?: string = "";
    activity?: string = "";
    demographics?: string = "";
    marketingPlan?: string = "";
    checkNo?: string = "";
    checkAmt?: number = 0;
    checkDate?: string = "";
    batchNum?: string = "";
    policyNo?: number = 0;

    // constructor(rosterNo: number, campusName: string, activity: string, checkNo: string, checkAmt: number, checkDate: string) {
    //     this.rosterNo = rosterNo;
    //     this.campusName = campusName;
    //     this.activity = activity;
    //     this.checkNo = checkNo;
    //     this.checkAmt = checkAmt;
    //     this.checkDate = checkDate;
    // }
}
